import { render, staticRenderFns } from "./SocketReload.vue?vue&type=template&id=d161db00&scoped=true&"
import script from "./SocketReload.vue?vue&type=script&lang=js&"
export * from "./SocketReload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d161db00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d161db00')) {
      api.createRecord('d161db00', component.options)
    } else {
      api.reload('d161db00', component.options)
    }
    module.hot.accept("./SocketReload.vue?vue&type=template&id=d161db00&scoped=true&", function () {
      api.rerender('d161db00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/JVxeDemo/demo/SocketReload.vue"
export default component.exports